export default function agreementFunction(response, navigate) {
  if (response.data.message === '_AGREEMENT_NOT_APPROVED_FROM_APP' ||
    response.data.result?.profile?.agree === '0') {
    navigate('/agreement');
  }
};
